<template>
  <div class="order" :class="$store.state.user.isNested && 'nestedHeader'">
    <!-- header -->
    <!--    <div class="header">{{ l.o_list_nav_bar }}</div>-->
    <div class="form_box">
      <Tabs @change="tabChange" v-model="activeName" ref="tabsStatus">
        <Tab :title="l.o_list_audit_result" name="1"></Tab>
        <Tab :title="l.o_list_for_reimbursement" name="2"></Tab>
        <Tab :title="l.o_list_for_clarify" name="3"></Tab>
      </Tabs>
    </div>
    <!-- tab -->
    <PullRefresh
        class="PullRefresh_con"
        v-model="isLoading"
        :pulling-text="l.o_list_pulling_text"
        :loosing-text="l.o_list_loosing_text"
        :loading-text="l.o_list_loading_text"
        @refresh="rendered"
    >
      <div class="list_con" :class="orders && orders.length && 'list_con_have'">
        <template v-if="orders && orders.length">
          <div
              class="orderList"
              @click="pathPush(item)"
              v-for="(item, index) in orders"
              :key="index"
          >
            <div class="orderNesc">
              <div class="orderMerchant">
                <img class="orderMerchantImg" :src="item.logo" alt=""/>
                <div class="orderMerchantName">{{ item.mchName }}</div>
              </div>
              <div class="orderDetail">
                <Icon class="orderDetail_icon" name="arrow"/>

                <div class="orderItem">
                  <!--                  <div class="orderTitle">{{ l.o_item_status }}:</div>-->
                  <div
                      class="orderStatus"
                      :class="orderStatusClass[item.orderStatusIndex]"
                  >
                    {{
                      item.loan_status == "6" ? item.penalty_days ? l.home_Overdue_day + item.penalty_days + l.home_unit_day : orderStatus[item.orderStatusIndex] : orderStatus[item.orderStatusIndex]
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="orderItemBox">
              <div class="orderItem">
                <div class="orderTitle">
                  {{
                    [6, 7].includes(item.orderStatusIndex)
                        ? l.o_item_borrowing_principal2
                        : item.isLoanAmount
                            ? l.o_loan_loan_amounts
                            : l.o_loan_maximum_borrowing
                  }}
                </div>
                <div class="orderAmount">
                  NT$
                  {{
                    [6, 7].includes(item.orderStatusIndex)
                        ? item.remainAmount
                        : item.isLoanAmount
                            ? item.principal
                            : loanNumber
                  }}
                </div>
              </div>
              <div class="orderItem">
                <div class="orderTitle">
                  {{
                    activeName == "2"
                        ? l.o_details_timely_time
                        : l.o_details_application_time
                  }}
                </div>
                <div class="orderAppTime">
                  {{ activeName == "2" ? item.deposit_time : item.app_time }}
                </div>
              </div>
            </div>
            <div class="orderBtn">
              <div
                  v-if="![10, 1, 6, 7, 2,0,5].includes(item.orderStatusIndex)"
                  class="orderDetail"
                  :class="orderStatusClass[item.orderStatusIndex]"
              >
                {{ l.o_check_details }}
              </div>
              <div
                  v-if="item.orderStatusIndex == 10"
                  class="orderDetail"
                  :class="orderStatusClass[item.orderStatusIndex]"
              >
                {{ l.o_click_withdrawal }}
              </div>
              <div
                  v-if="item.orderStatusIndex == 1 || item.orderStatusIndex == 2 || item.orderStatusIndex == 5"
                  class="orderDetail"
                  :class="orderStatusClass[item.orderStatusIndex]"
              >
                {{ l.o_apply_again }}
              </div>
              <div
                  v-if="item.orderStatusIndex == 6 || item.orderStatusIndex == 7"
                  class="orderDetail"
                  :class="orderStatusClass[item.orderStatusIndex]"
              >
                {{ l.o_click_repay }}
              </div>
            </div>
          </div>
          <div style="height: 150px;"></div>
        </template>
        <Empty v-if="orders && orders.length == 0">
          <template #image>
            <img :src="emptyImg" class="emptyImg" alt=""/>
            <div class="empty_box">
              <div class="emptyText">{{ l.o_none_order_record }}</div>
              <Button
                  @click="$router.push('/')"
                  type="info"
                  class="bottom-button emptyButton"
              >{{ l.o_go_loan }}
                <img class="emptyButton_arrow" src="@/assets/order/arrowright.png">
              </Button>
            </div>
          </template>
        </Empty>
      </div>
    </PullRefresh>
  </div>
</template>

<script>
import {Empty, Button, PullRefresh, Tab, Tabs, Icon, Toast} from "vant";
import {loanappqueryList} from "../../services/order";
import {queryproductsSaas} from "@/services/home";
import {config} from "@/services/user";
import l from "../../locales";
import {
  orderStatus,
  // orderList
} from "../../utils/maps";
import {formatMoney} from "../../utils";

export default {
  name: "order",
  components: {
    Empty,
    Button,
    PullRefresh,
    Tab,
    Tabs,
    Icon,
  },
  data() {
    return {
      orders: [],
      isLoading: false,
      l: {...l.orderItem, ...l.other, ...l.home},
      emptyImg: require("../../assets/order/emtpy.png"),
      orderStatusClass: [
        "underReview", //审核中 0
        "reject", //拒绝 1
        "cancel", //取消 2
        "lending", //放款中 3
        "failure", //放款失败 4
        "finish", //完成 5
        "repaid", //待还款 6
        "overdue", //逾期 7
        "timeoutRefuse", //超时拒绝 8
        `Return`, //退回9
        `Withdraw`, //待提现10
      ],
      orderStatus: orderStatus,
      activeName: "1",

      isLoanAmount: true,
      isNewLoan: true,
      loanNumber: "",
    };
  },
  methods: {
    formatMoney,
    tabChange() {
      this.rendered();
    },
    pathPush(item) {
      console.log(item);
      if (item.orderStatusIndex == 1) {
        if (item.data_status == 1) {
          // this.$router.push("/home");
          this.$router.push({
            path: "/confirmLoan",
            query: {
              mchId: item.mchId,
            },
          });
        } else {
          Toast.fail(
              this.l.o_loan_please_try_after.replace(
                  "$1",
                  this.addDays(item.approval_time, 7)
              )
          );
        }
      } else if (item.orderStatusIndex == 2 || item.orderStatusIndex == 5) {
        // this.$router.push("/home");

        this.$router.push({
          path: "/confirmLoan",
          query: {
            mchId: item.mchId,
          },
        });
      } else if (item.orderStatusIndex == 10) {
        this.$router.push({
          path: "/confirmWithdrawal",
          query: {busiId: item.busiId, mchId: item.mchId},
        });
      } else if (item.orderStatusIndex == 0) {
        return;
      } else {
        this.$router.push({path: "/detail", query: {busiId: item.busiId}});
      }
    },
    rendered() {
      console.log("rendered");
      this.orders = [];
      if (this.$store.state.user.userInfo.user_id) {
        loanappqueryList({
          orderType: this.activeName,
        }).then((res) => {
          // console.log("132", res);
          if (res.code == 200) {
            this.orders = res.result;
            // this.orders.push(...JSON.parse(JSON.stringify(this.orders)));
            // this.orders.push(...JSON.parse(JSON.stringify(this.orders)));
            // this.orders.push(...JSON.parse(JSON.stringify(this.orders)));
            // this.orders.push(...JSON.parse(JSON.stringify(this.orders)));
            // this.orders = orderList;
            this.init();
          }
          this.isLoading = false;
        });
      }
    },
    addDays(date, days) {
      var nd = new Date(date);
      nd = nd.valueOf();
      nd = nd + days * 24 * 60 * 60 * 1000;
      nd = new Date(nd);
      var y = nd.getFullYear();
      var m = nd.getMonth() + 1;
      var d = nd.getDate();
      if (m <= 9) m = "0" + m;
      if (d <= 9) d = "0" + d;
      var cdate = y + "-" + m + "-" + d;
      return cdate;
    },
    init() {
      this.orders.map((order) => {
        // order.loan_status = k;
        // console.log(order.loan_status);
        order.loan_status = parseInt(order.loan_status);
        // switch (order.loan_status) {
        //   case 1:
        //   case 10:
        //     order.orderStatusIndex = 0;
        //     break;
        //   case 2:
        //     order.orderStatusIndex = 2;
        //     break;
        //   case 3:
        //     order.orderStatusIndex = 1;
        //     break;
        //   case 4:
        //     order.orderStatusIndex = 3;
        //     break;
        //   case 5:
        //     order.orderStatusIndex = 6;
        //     break;
        //   case 6:
        //   case 8:
        //     order.orderStatusIndex = 5;
        //     break;
        //   case 7:
        //     order.orderStatusIndex = 7;
        //     break;
        //   case 9:
        //     order.orderStatusIndex = 4;
        //     break;
        //   case 99:
        //     order.orderStatusIndex = 10;
        //     break;
        //   case 199:
        //     order.orderStatusIndex = 9;
        //     break;
        // }

        order.isLoanAmount = true;
        switch (order.loan_status) {
          case 2:
            order.orderStatusIndex = 0;
            if (!this.isNewLoan) {
              order.isLoanAmount = false;
            }
            break;
          case 3:
            order.orderStatusIndex = 1;
            if (!this.isNewLoan) {
              order.isLoanAmount = false;
            }
            break;
          case 4:
            order.orderStatusIndex = 6;
            break;
          case 5:
            order.orderStatusIndex = 3;
            break;
          case 6:
            order.orderStatusIndex = 7;
            break;
          case 9:
            order.orderStatusIndex = 5;
            break;
          case 99:
            order.orderStatusIndex = 10;
            break;
        }
        switch (order.bid_status) {
          case 6:
            order.orderStatusIndex = 4;
            break;
          case 7:
            order.orderStatusIndex = 2;
            if (!this.isNewLoan) {
              order.isLoanAmount = false;
            }
            break;
          case 8:
            order.orderStatusIndex = 1;
            if (!this.isNewLoan) {
              order.isLoanAmount = false;
            }
            break;
        }

        return order;
      });
      // order.loan_status = "4";
      // order.data_status = 1;
      // order.bid_status = 0;
      console.log("this.orders", this.orders);
    },
    async getProductSaas() {
      let productsSaas = await queryproductsSaas();
      this.isNewLoan = productsSaas.result.isNewLoan;
      localStorage.setItem("isNewLoan", this.isNewLoan ? "1" : "2");
      console.log("getProductSaas", productsSaas);
    },
    async getConfig() {
      let conf = JSON.parse(localStorage.getItem("config") || "{}");

      if (!conf) {
        let res = await config();
        conf = res.result;
      }
      // console.log("conf", conf.result);
      this.loanNumber = conf.loan_max_amount;
      console.log("getConfig");
    },
  },
  async activated() {
    if (this.$store.state.user.userInfo.user_id) {
      if (this.$route.query.orderType) {
        console.log(
            "this.$route.query.orderType",
            this.$route.query.orderType + ""
        );
        this.$set(this, "activeName", this.$route.query.orderType + "");
      }
      this.$refs.tabsStatus.resize();

      await Promise.all[(await this.getProductSaas(), await this.getConfig())];

      this.rendered();
    }
  },
};
</script>

<style lang="less" scoped>
.order {
  width: 100%;
  //height: 100%;
  //background: url("../../assets/home/bgc.png") no-repeat #fff;
  //background-size: 100%;

  padding-top: 20px;
  box-sizing: border-box;


  .header {
    padding-top: 20px;
    box-sizing: border-box;
    text-align: center;

    height: 40px;

    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .PullRefresh_con {
    height: 100%;
    min-height: calc(100vh - 40px);
    overflow-y: auto;
  }
}

.form_box {
  padding: 0 20px;
  //margin-top: 20px;

  /deep/ .van-tabs,
  /deep/ .van-tabs__wrap {
    border-radius: 13px;
  }

  /deep/ .van-tabs__nav {
    background: transparent;
  }

  /deep/ .van-tabs--line .van-tabs__wrap {
    height: 50px;
    padding: 2px 0;
  }

  /deep/ .van-tabs__content {
    margin-top: 22px;
    padding: 0 20px;
  }

  /deep/ .van-tabs__line {
    // display: none;
    height: 4px;
    background: #0f821d;
    border-radius: 100px;
    opacity: 0.8;
    transform: translateY(-10px);

    display: none;
  }

  /deep/ .van-tab {
    //width: 90px;
    height: 100%;
    box-sizing: border-box;

    .van-tab__text {
      display: inline;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #959DA8;

      background: rgba(255, 255, 255, 0.5);
      border-radius: 15px;
      border: 1px solid #B0B0B0;
      padding: 5px 15px;
      box-sizing: border-box;


    }
  }

  /deep/ .van-tab:nth-child(1) {
    margin-left: 2px;
  }

  /deep/ .van-tab:nth-child(3) {
    margin-right: 2px;
  }

  /deep/ .van-tab--active {
    .van-tab__text {
      overflow: visible;
      position: relative;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #2980F6;

      background: rgba(16, 103, 219, 0.1);
      border: 1px solid #2980F6;


      //&:after{
      //  content: "";
      //  position: absolute;
      //  top: -4px;
      //  right: 0;
      //  transform: translateX(100%);
      //  // display: none;
      //
      //  width: 12px !important;
      //  height: 12px;
      //  //transform: translateY(-10px);
      //  background: url("../../assets/order/coin.png") no-repeat;
      //  background-size: 100%;
      //}
    }
  }
}

.list_con {
  position: relative;
  margin: 0 20px;

  .orderList {
    position: relative;
    margin-bottom: 15px;

    width: 100%;
    //padding: 20px;
    padding-bottom: 15px;
    box-sizing: border-box;

    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(56, 151, 229, 0.2);
    border-radius: 15px;
    border: 1px solid #DDE3E9;


    .orderNesc {
      display: flex;
      align-items: center;
      justify-content: space-between;

      width: 100%;
      box-sizing: border-box;

      height: 62px;
      padding: 16px 20px;
      padding-right: 0;

      .orderMerchant {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .orderMerchantImg {
          width: 30px;
          height: 30px;
          background: #E9EDF1;

          border-radius: 50%;
          margin-right: 12px;
        }

        .orderMerchantName {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #28435B;

        }
      }

      .orderDetail {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #45A1FF;

        .orderDetail_icon {
          font-size: 20px;
          display: none;
        }

        .orderItem {
          .orderStatus {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #45A1FF;
            width: 120px;
            min-height: 28px;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #D2E3F7 100%);


            display: flex;
            align-items: center;
            justify-content: flex-end;
            text-align: center;

            //padding-left: 66px;
            padding-right: 15px;
            box-sizing: border-box;
          }


          .reject,
          .overdue, .failure {
            color: #EC1E1E;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FCDBDB 100%);
          }
        }
      }
    }

    .orderItemBox {
      padding: 12px 20px;
      padding-left: 42px;
      height: 60px;
      border-top: 1px solid #DDE3E9;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .orderItem {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        //margin: 12px 0;

        .orderTitle {
          width: 100%;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #959DA8;
          margin-bottom: 6px;
        }

        .orderAmount {
          width: 100%;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #28435B;
        }

        .orderAppTime {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #28435B;
        }

        .orderStatus {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #45A1FF;
        }

        .reject {
          color: #FF3E1F;
        }

        .overdue {
          color: #FF3E1F;
        }

        .Withdraw {
          color: #1aa0ff;
        }
      }
    }

    .orderBtn {
      display: flex;
      justify-content: center;
      padding: 3px 20px;
      padding-bottom: 0;
      box-sizing: border-box;

      .orderItem {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        //margin: 12px 0;

        .orderTitle {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6D707B;
        }

        .orderStatus {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #45A1FF;
          margin-left: 4px;
        }

        .reject,
        .overdue {
          color: #FF3E1F;
          background: none;
        }

        .overdue {
          color: #FF3E1F;
        }

        //.Withdraw {
        //  color: #1aa0ff;
        //}
      }

      .orderDetail {
        width: 155px;
        min-height: 35px;
        background: rgba(16, 103, 219, 0.1);
        border: 1px solid #2980F6;
        border-radius: 22px;
        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #2980F6;

        display: flex;
        align-items: center;
        justify-content: center;
      }

      //.reject,
      //.overdue {
      //  color: #FFFFFF;
      //  background: #FF3E1F;
      //  //background: rgba(255, 58, 26, 0.2);
      //}
    }
  }

  /deep/ .van-empty {
    height: 100%;
    width: 100%;
    padding: 0;
  }

  .emptyImg {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 183px;
    height: 150px;
  }

  .empty_box {
    position: absolute;
    top: 240px;
    left: 50%;
    transform: translateX(-50%);
    width: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .emptyText {
    //position: absolute;
    //top: 280px;
    //left: 50%;
    //transform: translateX(-50%);
    //width: 100vw;
    width: 100%;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #8892A0;
    margin-right: 8px;

  }

  .emptyButton {
    //position: absolute;
    //top: 316px;
    //left: 50%;
    //transform: translateX(-50%);
    border: none;
    background: transparent;
    padding: 0;
    width: 100%;

    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #3387F8;

    .emptyButton_arrow {
      width: 16px;
      height: 16px;
    }

  }
}

.list_con_have {
  background: transparent;
  height: 100%;
  //overflow-y: auto;
}
</style>
